import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.less';
import reportWebVitals from './reportWebVitals';


import {
  BrowserRouter as Router,
  Switch
} from "react-router-dom";

import renderRoutes from 'router/renderRoutes';
import routes from 'router/router.js';
const authed = false // 如果登陆之后可以利用redux修改该值(关于redux不在我们这篇文章的讨论范围之内）
const authPath = '/login';



ReactDOM.render(
  <React.StrictMode>
    <Router>
        <Switch>
        {renderRoutes(routes, authed, authPath)}
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
